import React from 'react'
import "../../style/Modal.css"
import { TwitterShareButton } from 'react-share';


const ModalContent = ({ handleCloseClick,image,handleSaveClick  }) => {
  return (
    <div className="modal">
      <div className="modal__content">
        <div id="result">
          <img src={image} alt="avatarImage" />
        </div>
        <button className="modal__close__button" type="button" onClick={handleCloseClick} />
        <div className="modal__buttons">
          <p className='modal__memo'>
            ★<span style={{color: "red", fontWeight: "bold"}}>上手く表示されない場合</span>はもう一度完成ボタンを押し直してください<br/>
            ★ツイートする場合の画像はご自身で添付してください<br/>
            ★<span style={{color: "red",fontWeight: "bold"}}>携帯からは</span>画像を長押しして保存してください<br/>
            ★<span style={{color: "red",fontWeight: "bold"}}>モニターの場合、背景が反映されないことがあります。</span>
          </p>
          <button className="modal__save__button parts-name" onClick={handleSaveClick} >png画像保存</button>
          <TwitterShareButton
            hashtags={["KumaAvatar", "くまアバター"]}
            url={'https://kuma-avatar.vercel.app/'}
          >
            <div className="modal__share__button">
              共有
            </div>
          </TwitterShareButton>
        </div>
      </div>
    </div>
  );
};

export default ModalContent;
